import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/packagePrograms', request)
}

async function post(request) {
    return await postMethod('/api/packagePrograms', request)
}

export {get, post}
